import {
  CREATE_CATEGORY_BLOCKED_TOOLTIP,
  CREATE_PRODUCT_BLOCKED_TOOLTIP,
  getCurrentCompanyCatalogFlags,
} from '@/utils/companyCatalogFlags';

const companyCatalogFlagsMixin = {
  data() {
    return {
      canCreateCategory: true,
      canCreateProduct: true,
      createCategoryBlockedTooltip: CREATE_CATEGORY_BLOCKED_TOOLTIP,
      createProductBlockedTooltip: CREATE_PRODUCT_BLOCKED_TOOLTIP,
    };
  },
  computed: {
    isCreateCategoryBlocked() {
      return !this.canCreateCategory;
    },
    isCreateProductBlocked() {
      return !this.canCreateProduct;
    },
  },
  created() {
    this.loadCompanyCatalogFlags();
  },
  methods: {
    async loadCompanyCatalogFlags() {
      const flags = await getCurrentCompanyCatalogFlags();
      this.canCreateCategory = flags.allowCreateCategory;
      this.canCreateProduct = flags.allowCreateProduct;
    },
    ensureCanCreateCategory() {
      if (this.canCreateCategory) {
        return true;
      }
      this.showCatalogBlockedToast(this.createCategoryBlockedTooltip);
      return false;
    },
    ensureCanCreateProduct() {
      if (this.canCreateProduct) {
        return true;
      }
      this.showCatalogBlockedToast(this.createProductBlockedTooltip);
      return false;
    },
    showCatalogBlockedToast(message) {
      if (typeof this.makeToastFaile === 'function') {
        this.makeToastFaile(message);
        return;
      }
      this.$bvToast.toast(message, {
        title: 'Thông báo',
        variant: 'warning',
        solid: true,
      });
    },
  },
};

export default companyCatalogFlagsMixin;
